import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'Button';
import { useTranslation } from 'react-i18next';

export function DismissButton({ onPress }: { onPress: () => void }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'Card.card' });

    return (
        <Button
            isIconOnly
            aria-label={t('dismiss')}
            onPress={onPress}
            variant="bordered-white"
            height={8}
            color="slate-grey"
            round
        >
            <FontAwesomeIcon className="text-lg text-black" icon={faXmark} />
        </Button>
    );
}
